















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { JobDetail, Image, Company, Worker, Conversation } from '@/@types/LibraryComponent';
import JobTitle from './JobTitle.vue';
import EyeCatch from './EyeCatch.vue';
import JobArticle from './JobArticle.vue'
import Member from './Member.vue';
import Condition from './Condition.vue';
import Contact from './Contact.vue';
import ApplicationForm from './ApplicationForm.vue';

@Component({
  components: {
    JobTitle,
    EyeCatch,
    JobArticle,
    Member,
    Condition,
    Contact,
    ApplicationForm,
  },
})
export default class JobDetailModal extends Vue {
  @Prop()
  private id!: string;
  private job: JobDetail = require('@/repository/mock/dummyData/job/jobDetail.json').job;

  @Emit()
  private closeDetail() {
    this.$emit('closeDetail');
  }
}
